import React from "react";
import PropTypes from 'prop-types';
import MainTitle from './MainTitle';
import TextBlock from './TextBlock';
import DownloadNowButton from '../../../containers/features/elements/DownloadNowButton';
import BrowseCatalogButton from './BrowseCatalogButton';

export default class FeatureBlock extends React.PureComponent {
    renderCatalogButton = () => {
        let { isCatalogButton } = this.props;

        if (!isCatalogButton) {
            return false;
        }

        return (
            <BrowseCatalogButton/>
        )
    };
    render() {
        let { title, text, className, children, isButtonLabel } = this.props;

        return (
            <div className={'feature-wrapper'}>
                <div className={'feature-block ' + className}>
                    <MainTitle text={title}/>
                    <TextBlock text={text}>{children}</TextBlock>

                    {this.renderCatalogButton()}

                    <DownloadNowButton isButtonLabel={isButtonLabel}/>
                </div>
            </div>
        );
    }
}

FeatureBlock.propTypes = {
    isButtonLabel: PropTypes.bool,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    text: PropTypes.string,
    className: PropTypes.string,
    isCatalogButton: PropTypes.bool,
};
